import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScrollService implements OnDestroy {
    private readonly scrollSubject$: Subject<void> = new Subject<void>();

    // Observable that components can subscribe to
    public scrollObservable$: Observable<void> = this.scrollSubject$.asObservable();

    public ngOnDestroy(): void {
        this.scrollSubject$.complete();
    }

    // Method to trigger the scroll event
    public triggerScrollEvent(): void {
        this.scrollSubject$.next();
    }
}
